<template>
  <div class="tir-pm-comment-chat-date-separator">
    <div class="tir-pm-comment-chat-date-separator__datetime-indicator">Сегодня</div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss">
@import "./style/tir-pm-comment-chat-date-separator";
</style>
